export const updateMarket = ({ commit }, market) => {
  commit('SUBMIT_MARKET', market);
};
